import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { MermaidGraph } from 'mermaid-graph';
import sort from '../../assets/icons/sort.svg';
import { getSurveyFlowchart } from '../../redux/survey/survey.endpoints';

interface SurveyBranchingPreviewProps {
  extSurveyId?: string;
}

const SurveyBranchingPreview: React.FC<SurveyBranchingPreviewProps> = ({ extSurveyId }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [flowchart, setFlowchart] = useState<string | null>(null);

  useEffect(() => {
    async function getData() {
      if (!extSurveyId) return;
      const data = await getSurveyFlowchart(extSurveyId);
      if (data) {
        setFlowchart(data);
      }
    }
    if (isVisible) {
      getData();
    }
  }, [isVisible, extSurveyId]);

  return (
    <>
      <button
        onClick={() => setIsVisible(true)}
        className="ml-2 flex items-center rounded-3xl bg-white lg-max:p-2 px-6 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-501"
      >
        <img
          className="w-6 h-6 mr-2 lg-max:m-0"
          src={sort}
          alt=""
          draggable={false}
        />
        <span className="lg-max:hidden">
          Preview Branching
        </span>
      </button>
      <Dialog
        visible={isVisible}
        onHide={() => setIsVisible(false)}
        header="Survey Branching Preview"
        className="w-11/12 h-5/6 p-4"
        draggable={false}
        blockScroll
      >
        <div className="h-full w-full flex items-center justify-center overflow-auto">
          {flowchart && (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <style>
                {`
                  .mermaid {
                    display: flex !important;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                  }
                  .mermaid svg {
                    max-width: 100% !important;
                    max-height: 100% !important;
                    width: auto !important;
                    height: auto !important;
                  }
                `}
              </style>
              <MermaidGraph
                graphCode={flowchart}
              />
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default SurveyBranchingPreview;